import React from 'react';
import styles from "./sections.module.css"
import {useSelector} from "react-redux";
import {getMatchingNamesAPI} from "../../../../../api/reviewsAPI";

const Commenter = ({commenterInfo, updateCommenter, trackingNumber, updateSavedState, isPaused, savedState}) => {

    const jwt = useSelector((state) => state.user.jwt);
    const docket = useSelector((state) => state.navigation.currentDocket);

    const [commenterName, setCommenterName] = React.useState(commenterInfo[0] ?? "")

    const [possibleCommenters, setPossibleCommenters] = React.useState([])

    const submitCommenterName = () => {
        updateCommenter(commenterName)
        updateSavedState(true)
    }

    const reset = () => {
        setCommenterName(commenterInfo[0] ?? "")
    }

    const clear = () => {
        updateCommenter("")
        updateSavedState(true)
    }

    React.useEffect(() => {
        if (commenterName !== commenterInfo[0]) {
            updateSavedState(false)
        } else {
            updateSavedState(true)
        }
    }, [commenterName])

    React.useEffect(() => {
        reset()
        getMatchingNamesAPI(jwt, docket, commenterInfo[0] ?? "").then(r => {
            if (r.success) {
                setPossibleCommenters([...r.data])
            }
        })
    }, [trackingNumber, commenterInfo])


    React.useEffect(() => {
        let timeoutInterval = setTimeout(() => {
            getMatchingNamesAPI(jwt, docket, commenterName).then(r => {
                if (r.success) {
                    console.log(r.data)
                    setPossibleCommenters([...r.data])
                }
            })
        }, 500)

        return () => {
            clearTimeout(timeoutInterval)
        }
    }, [jwt, docket, commenterName])

    return (
        <div className={styles.wrapperFlexLeft}>
            <p className={styles.label}>Commenter Name:</p>
            <input disabled={isPaused} onChange={e => setCommenterName(e.currentTarget.value)} value={commenterName}
                   className={styles.singleLineTextInput}/>
            <select disabled={isPaused} value={commenterName} onChange={e => setCommenterName(e.currentTarget.value)}
                    className={styles.multiSelect} name="inProgress" id="inProgress" size={8}>
                <option value={""}>---</option>
                {
                    possibleCommenters.map((commenterName, index) => (
                        <option key={`${commenterName}_${index}`} value={commenterName}>{commenterName}</option>
                    ))
                }
            </select>
            <div className={styles.lineItem}>
                <button className={styles.normalButton} disabled={isPaused || commenterName===""} onClick={clear}>Clear</button>
                <button className={styles.normalButton} disabled={isPaused || savedState}
                        onClick={submitCommenterName}>Save
                </button>
            </div>
        </div>
    );
};

export default Commenter;